<template>
  <div class="checkout-builder-text-preview">
    <div v-html="component.text" :style="style" />
  </div>
</template>

<script>
export default {
  props: {
    component: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    style() {
      const style = { ...this.component.config };

      return style;
    }
  }
};
</script>
